import { memo, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { KEY_FOR_DEPOSIT_SOURCE_ID, KEY_FOR_PAYMENT_AMOUNT, KEY_FOR_BANK_LIST } from 'shared-modules/constants/cash';
import { removeKeyFromSessionStorage } from 'shared-modules/services';
import { useCashMenu } from './hooks';
import styles from './cashMenu.module.scss';

export const CashMenu = memo(() => {
  const dispatch = useDispatch();
  const cashMenuList = useCashMenu();
  const serviceId = useSelector((state) => state.auth.serviceId);

  useEffect(() => {
    removeKeyFromSessionStorage({ key: KEY_FOR_DEPOSIT_SOURCE_ID });
    removeKeyFromSessionStorage({ key: KEY_FOR_PAYMENT_AMOUNT });
    removeKeyFromSessionStorage({ key: KEY_FOR_BANK_LIST });
  }, [dispatch]);

  return (
    <div>
      <div className={styles.mainMenuRow}>
        {cashMenuList.map((b) => (
          <div
            className={styles.buttonWrapper}
            onClick={() => b.callBack(serviceId)}
            role="button"
            aria-hidden
            key={b.key}
          >
            {b.icon}
            <div className={styles.buttonText}>
              <div className={styles.buttonTitle}>{b.title}</div>
              <div>
                <span className={styles.buttonDescription}>{b.description}</span>
                {Boolean(b?.remarks?.length) && <span className={styles.buttonRemarks}>{b.remarks}</span>}
              </div>
            </div>
            {b.subIcon}
          </div>
        ))}
      </div>
    </div>
  );
});
